import {Component, Inject, OnInit} from '@angular/core';
import {MatDialog, MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
    selector: 'dialog-html',
    templateUrl: 'dialog-html.component.html',
    styleUrls: ['dialog-html.component.scss']
})
export class DialogHTML implements OnInit {

    constructor(
        public dialogRef: MatDialogRef<DialogHTML>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {}

    ngOnInit() {
    }
    dismissDialog(){
        this.dialogRef.close();
    }
}